import * as http from './http'
import endpoints from './endpoints'
import * as Checkout from './CheckoutApi'
import { CartPageModel } from '@ViewModels/CartPageModel'
import { ProductStoreItemModel } from '@ViewModels/ProductStoreItemModel'

const apiCart = endpoints.cart
const apiProduct = endpoints.product

export const getModelData = async (): Promise<CartPageModel> => {
   const url = `${apiCart}`
   return http.get(url)
}

export const recoverCart = async (cartId: string): Promise<CommitResult> => {
   const url = `${apiCart}/recover?cartId=${cartId}`
   const result = (await http.post(url, {})) as CommitResult
   return result
}

export const updateCartItem = async (
   productPriceId: string,
   quantity: number
): Promise<CartPageModel> => {
   const url = `${apiCart}/items?productPriceId=${productPriceId}&qty=${quantity}`
   const result = (await http.post(url, {})) as CommitResult
   if (result.HasError) {
      throw new Error(result.ErrorMessage)
   } else {
      return (result.Data as any).Cart as CartPageModel
   }
}

export const quickAddSearch = async (searchTerm: string): Promise<ProductStoreItemModel | null> => {
   const url = `${apiProduct}?searchTerm=${encodeURIComponent(searchTerm)}`
   return (await http.get(url)) as ProductStoreItemModel
}

export const addPromocode = Checkout.addPromocode
export const removePromocode = Checkout.removePromocode
